import AxiosClient from '../AxiosClient';
import { SERVICE, ENV, COLLAB_ENV } from "../../Config/constants";
import { constructURL } from '../../Utils/index';

const service = AxiosClient.getInstance();

// Fetches Support FAQ list
export const getSupportFaq = async () => {
  const url = `${ENV}${SERVICE.SUPPORT.FETCH_FAQ}`;
  return service.GetApiRequest(url);
};


export const getSupportUnauthenticatedFaq = async () => {
  const langArray = localStorage.getItem('activeLanguageCountry').split("/");
  const country = langArray[1];
  const language = langArray[0];
  const baseUrl = `${ENV}${SERVICE.SUPPORT.UNAUTHENTICATED_FAQ}`;
  const url = constructURL(baseUrl,{country, language});
  return service.GetApiRequest(url);
};


export const getSupportCountries = async () => {
  const url = `${ENV}${SERVICE.SUPPORT.GET_COUNTRIES}`;
  return service.GetApiRequest(url);
};

export const getGeoIPCountry = async () => {
  const url = `${COLLAB_ENV}${SERVICE.SUPPORT.GEO_IP_LOCATOR}`;
  return service.GetApiRequest(url);
};

//Product Update List
export const productUpdateApi = async (language) => {
  const baseUrl = `${ENV}${SERVICE.SUPPORT.LOAD_PRODUCT_UPDATE}`;
  const url = constructURL(baseUrl, {language});
  return service.GetApiRequest(url);
};
